export default __webpack_public_path__ + "static/media/ccss.e210ae0d.png";